import { datadogRum } from 'root/datadog/datadogRum';

export default class Employee {
  lsEmployeeId: string;
  firstName: string;
  lastName: string;
  email: string;

  constructor(employee: MerchantosSessionEmployee | null) {
    if (!employee) {
      const error = new Error('Employee data is required for the invoicing module');
      datadogRum.addError(error);
    }

    this.lsEmployeeId = employee?.employeeID || '';
    this.firstName = employee?.firstName || '';
    this.lastName = employee?.lastName || '';
    this.email = employee?.email || '';
  }
}
